@if(isDetail){
  <div class="col-lg-12">
    <div class="mb-3">
        <h4>Categorias</h4>
        <ul class="list-unstyled fruite-categorie">
          <li>
            <div class="d-flex flex-column fruite-name">
              <div class="d-flex justify-content-between" >
                <a (click)="updateProducts()"><i class="fas fa-apple-alt me-2"></i>TODOS</a>
                
              </div >
            </div>
        </li>
          @for(catalog of catalogs; track catalog; let idx = $index) {
            <li>
                <div class="d-flex flex-column fruite-name">
                  <div  data-bs-toggle="collapse" [attr.data-bs-target]="'#'+'category'+ idx" aria-expanded="false" [attr.aria-controls]="'category'+ idx"
                  (click)="updateProducts(catalog.nombre)">
                    <div class="d-flex justify-content-between" >
                      <a ><i class="fas fa-apple-alt me-2"></i>{{catalog?.nombre}}</a>
                      <span>{{catalog?.count}}</span>
                    </div >
                  </div>
                    <div class="collapse collapse-horizontal" [id]="'category'+ idx" style="min-height: 120px;">
                      <ul>
                        @for(subCategories of catalog.categories; track subCategories) {
                          <li>
                            <div class="d-flex justify-content-between fruite-name">
                              <a (click)="updateProducts(catalog.nombre, subCategories.nombre)"><i class="fas fa-apple-alt me-2"></i>{{subCategories?.nombre}}</a>
                            </div>
                          </li>
                        }
                      </ul>
                    </div> 
                </div>
            </li>
          }
        </ul>
    </div>
  </div>
} @else {
  <div class="row g-4">
    <div class="col-lg-12 text-end">
      <ul class="nav nav-pills d-inline-flex text-center mb-5">
        <li class="nav-item">
          <a class="d-flex m-2 py-2 bg-light rounded-pill category-pill" data-bs-toggle="pill" (click)="updateProducts()">
              <span class=" category-pills">TODOS</span>
          </a>
        </li>
        @for(catalog of catalogs; track catalog) {
          <li class="nav-item">
              <a class="d-flex m-2 py-2 bg-light rounded-pill category-pill" data-bs-toggle="pill" (click)="updateProducts(catalog.nombre)">
                  <span class="category-pills">{{catalog?.nombre?.toUpperCase()}}</span>
              </a>
          </li>
        }

      </ul>
    </div>
  </div>
}

